import { __decorate, __metadata } from 'tslib';
import { NotEnumerable, Storable, Metadata, Store, deepExtends } from '@tencent/workbench-core';

/**
 * @internal
 */
class ActionPointMetadata extends Storable {
    constructor(provide, methodClassName) {
        super(provide, methodClassName, Object.getOwnPropertyDescriptor(provide, methodClassName));
        this.methodClassName = methodClassName;
        this.beforeMiddlewares = [];
        this.middlewares = [];
        this.afterMiddlewares = [];
        this.type = Metadata.getReturnType(this.rawTarget, this.methodName);
    }
    get methodName() {
        return this.methodClassName;
    }
    merge(args) {
        const middlewares = args.filter(arg => typeof arg !== 'string' && !!arg);
        this.middlewares = this.middlewares.concat(middlewares);
        return this;
    }
    get(key) {
        const ctrlValue = Store.from(this.target).get(key);
        let meta = deepExtends(undefined, ctrlValue);
        const pointValue = this.store.get(key);
        if (pointValue !== undefined) {
            meta = deepExtends(meta, pointValue);
        }
        return meta;
    }
    before(args) {
        this.beforeMiddlewares = this.beforeMiddlewares.concat(args);
        return this;
    }
    after(args) {
        this.afterMiddlewares = this.afterMiddlewares.concat(args);
        return this;
    }
    inherit(target) {
        const metadata = new ActionPointMetadata(target, this.methodClassName);
        metadata.inheritedEndpoint = this;
        metadata.middlewares = this.middlewares;
        metadata.beforeMiddlewares = this.beforeMiddlewares;
        metadata.afterMiddlewares = this.afterMiddlewares;
        return metadata;
    }
}
__decorate([
    NotEnumerable(),
    __metadata("design:type", Array)
], ActionPointMetadata.prototype, "beforeMiddlewares", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Array)
], ActionPointMetadata.prototype, "middlewares", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Array)
], ActionPointMetadata.prototype, "afterMiddlewares", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", ActionPointMetadata)
], ActionPointMetadata.prototype, "inheritedEndpoint", void 0);

export { ActionPointMetadata };
//# sourceMappingURL=action-point-metadata.js.map
